import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { isMobile, prefersReducedMotion, qs, qsa } from '@/lib/dom'

/** 背景に流れる大きな装飾テキストの並び。CSS 側で position:absolute / white-space:nowrap。 */
const SCRUB_SELECTORS = ['.scrub-text', '.scrub-text-10thcontent', '.scrub-text-share'] as const

/**
 * スクロール量に応じて装飾テキストを横に流す。
 * `p` の中に同じ文言の `span` が複数並んでいるので、1 セット分の幅だけ動かせば
 * 見た目が途切れず繋がる。
 */
export function initScrubText(): void {
  if (prefersReducedMotion()) return

  // SP では動かさない。
  //
  // この装飾は position:sticky の全幅コンテナの中で、画面数枚ぶんの幅がある
  // 巨大な一行テキストを平行移動させている。スクロールのたびにその大きな面を
  // 作り直すことになり、指の動きに対して描画が遅れる（＝カクつく）。
  // SP では合成後の不透明度が 0.05 とほぼ見えないため、動きだけを止めて
  // 文字はそのまま置いておく。見た目は変わらず、描画の負担だけが消える。
  if (isMobile()) return

  SCRUB_SELECTORS.forEach((selector) => {
    qsa<HTMLElement>(selector).forEach((container) => {
      const line = qs<HTMLElement>('p', container)
      const firstSpan = qs<HTMLElement>('span', container)
      if (!line || !firstSpan) return

      const shift = (): number => firstSpan.offsetWidth

      gsap.fromTo(
        line,
        { x: 0 },
        {
          x: () => -shift(),
          ease: 'none',
          scrollTrigger: {
            trigger: container,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
            invalidateOnRefresh: true,
          },
        },
      )
    })
  })

  ScrollTrigger.refresh()
}
